/* BLED PALESTINE — page produit DSTAP. Vanilla JS, IntersectionObserver, transform/opacity uniquement.
   Sans JS ou prefers-reduced-motion : rien ne s'exécute, tout reste visible (rendu statique). */
(function(){
  var root=document.querySelector('[data-pal]');if(!root)return;
  var rm=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(rm||!('IntersectionObserver' in window)||!window.requestAnimationFrame)return;
  root.classList.add('pal-js');

  /* ---------- Compteurs + apparitions ---------- */
  var nf=function(v,dec){return v.toLocaleString('fr-FR',{minimumFractionDigits:dec,maximumFractionDigits:dec})};
  function count(el){
    var to=parseFloat(el.getAttribute('data-pal-count'))||0,dec=+(el.getAttribute('data-dec')||0),yr=el.hasAttribute('data-year');
    var from=yr?to-80:0,t0=null,d=1700;
    function f(t){if(!t0)t0=t;var p=Math.min(1,(t-t0)/d),e=1-Math.pow(1-p,4),v=from+(to-from)*e;
      el.textContent=yr?String(Math.round(v)):nf(dec?Math.round(v*10)/10:Math.round(v),dec);if(p<1)requestAnimationFrame(f)}
    el.textContent=yr?String(from):nf(0,dec);requestAnimationFrame(f)}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;var n=e.target;n.classList.add('is-in');
    var c=n.querySelectorAll('[data-pal-count]');for(var i=0;i<c.length;i++)count(c[i]);io.unobserve(n)})},{rootMargin:'0px 0px -10% 0px',threshold:.05});
  root.querySelectorAll('[data-pal-rv]').forEach(function(n){io.observe(n)});

  /* ---------- Outils ---------- */
  function cl(v){return v<0?0:v>1?1:v}
  function seg(p,a,b){return cl((p-a)/(b-a))}
  function io3(t){return t<.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2}
  function oe(t){return 1-Math.pow(1-t,3)}
  var vw=innerWidth,vh=innerHeight;

  /* ---------- Spectacle épinglé ---------- */
  var show=root.querySelector('[data-pal-show]');
  var tee=root.querySelector('[data-pal-tee]'),slog=root.querySelector('[data-pal-slog]'),kef=root.querySelector('[data-pal-kef]');
  var chs=[].slice.call(root.querySelectorAll('[data-pal-ch]')),rows=[].slice.call(root.querySelectorAll('[data-pal-row]'));
  var caps=[].slice.call(root.querySelectorAll('[data-pal-cap]')),sprog=root.querySelector('[data-pal-sprog]');
  var skins=[].slice.call(root.querySelectorAll('[data-pal-skin]')),skinName=root.querySelector('[data-pal-skin-name]'),frame=root.querySelector('[data-pal-frame]');
  var cuts=[0,.12,.25,.35,.5,.68,.86,1.01],capI=0,skinI=0,frameOn=false,showOn=false,H=1;
  /* vecteurs d'explosion déterministes (angle d'or) */
  var vec=chs.map(function(c,i){var a=i*2.39996+.4,r=.55+((i*7)%5)/7;return{x:Math.cos(a)*r,y:Math.sin(a)*r,rot:((i*53)%140)-70,s:.6+((i*3)%4)/3}});
  function measure(){vw=innerWidth;vh=innerHeight;H=tee?tee.offsetHeight:1;if(tl)tlMeasure()}
  function renderShow(){
    var r=show.getBoundingClientRect(),len=r.height-vh;if(len<=0)return;
    var p=cl(-r.top/len);
    var e1=oe(seg(p,0,.1)),e2=io3(seg(p,.1,.24)),e3=seg(p,.22,.34),e4=io3(seg(p,.34,.52)),e5=seg(p,.46,.7),ret=io3(seg(p,.62,.72)),e6=seg(p,.7,.88),e7=oe(seg(p,.86,.97));
    /* T-shirt : entrée, zoom sur la poitrine, retrait, retour, rotation dans les 6 coloris, atterrissage */
    var z=1+1.6*e2+1.2*e3, zz=z+(1-z)*ret, focus=Math.min(1,e2*1.2)*(1-ret);
    var s=(.7+.3*e1)*zz*(1-.14*e7), ty=.19*H*s*focus, rot=-12*(1-e1);
    var th=e6*6*Math.PI, sx=Math.abs(Math.cos(th)), hop=-Math.sin(e6*Math.PI)*H*.12, wob=Math.sin(th)*5;
    if(e6>0&&e6<1){sx=Math.max(.04,sx)}else sx=1;
    var op=cl(1-seg(p,.21,.29)*.97+ret);
    tee.style.transform='translate3d(0,'+(ty+hop).toFixed(1)+'px,0) rotate('+(rot+wob).toFixed(2)+'deg) scale('+(s*sx).toFixed(4)+','+s.toFixed(4)+')';
    tee.style.opacity=op.toFixed(3);
    var k=e6>=1?skins.length*0:Math.floor(th/Math.PI+.5);
    var ns=skins.length?((k%skins.length)+skins.length)%skins.length:0;if(e6>=1)ns=0;
    if(ns!==skinI&&skins[ns]){skins[skinI].classList.remove('is-cur');skins[ns].classList.add('is-cur');skinI=ns;if(skinName)skinName.textContent=skins[ns].getAttribute('data-name')}
    if(skinName)skinName.style.opacity=(e6>0&&e6<1?1:0)*1+'';
    /* Slogan : décolle du coton puis explose en lettres */
    var so=seg(p,.2,.27)*(1-seg(p,.5,.58));
    slog.style.opacity=so.toFixed(3);
    slog.style.transform='translateY(-50%) translateY('+((1-e3)*-.02*H).toFixed(1)+'px) scale('+(.62+.55*e3+.25*e4).toFixed(3)+')';
    var D=Math.max(vw,vh)*.9;
    for(var i=0;i<chs.length;i++){var v=vec[i];chs[i].style.transform=e4>0?'translate3d('+(v.x*D*e4).toFixed(1)+'px,'+(v.y*D*e4).toFixed(1)+'px,0) rotate('+(v.rot*e4*2).toFixed(1)+'deg) scale('+(1+(v.s-1)*e4).toFixed(3)+')':''}
    /* Keffieh qui tourne derrière */
    kef.style.transform='rotate('+(e4*45+e5*30).toFixed(2)+'deg) scale('+(1+e4*.6).toFixed(3)+')';
    kef.style.opacity=(.05+.12*e4*(1-ret)).toFixed(3);
    /* Écho : la phrase se multiplie, rangée après rangée */
    var out=seg(p,.66,.74);
    for(var j=0;j<rows.length;j++){var a=seg(p,.44+j*.017,.5+j*.017),dir=j%2?1:-1;
      rows[j].style.opacity=(a*(1-out)).toFixed(3);
      rows[j].style.transform='translate3d('+(dir*(e5*.6+.1)*vw).toFixed(1)+'px,0,0) scaleY('+oe(a).toFixed(3)+')'}
    /* Légendes + progression */
    var c=0;for(var q=0;q<cuts.length-1;q++)if(p>=cuts[q])c=q;
    if(c!==capI){caps[capI].classList.remove('is-on');caps[c].classList.add('is-on');capI=c}
    if(sprog)sprog.style.transform='scaleX('+p.toFixed(4)+')';
    var fo=p>.88;if(fo!==frameOn){frame.classList.toggle('is-on',fo);frameOn=fo}
  }

  /* ---------- Frise horizontale épinglée ---------- */
  var tl=root.querySelector('[data-pal-tl]'),track=root.querySelector('[data-pal-track]'),tlvp=root.querySelector('[data-pal-tlvp]'),tlp=root.querySelector('[data-pal-tlprog]'),dist=0,tlOn=false;
  function tlMeasure(){if(!track)return;var pad=parseFloat(getComputedStyle(tlvp).paddingLeft)||0;dist=Math.max(0,track.scrollWidth+pad*2-vw);tl.style.height=(dist+vh)+'px'}
  function renderTl(){var r=tl.getBoundingClientRect(),p=dist?cl(-r.top/dist):0;
    track.style.transform='translate3d('+(-p*dist).toFixed(1)+'px,0,0)';if(tlp)tlp.style.transform='scaleX('+p.toFixed(4)+')'}

  /* ---------- Barre collante ---------- */
  var bar=root.querySelector('[data-pal-bar]');
  function renderBar(){if(!bar)return;var rr=root.getBoundingClientRect();bar.classList.toggle('is-on',rr.top<vh*.35&&rr.bottom>vh*.9)}

  var tk=false;
  function frame_(){tk=false;if(showOn&&show)renderShow();if(tlOn&&tl)renderTl();renderBar()}
  function req(){if(!tk){tk=true;requestAnimationFrame(frame_)}}
  var vio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.target===show)showOn=e.isIntersecting;if(e.target===tl)tlOn=e.isIntersecting});req()},{rootMargin:'200px 0px'});
  if(show)vio.observe(show);if(tl)vio.observe(tl);
  measure();
  addEventListener('scroll',req,{passive:true});
  var rt;addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(function(){measure();req()},120)});
  addEventListener('load',function(){measure();req()});
  req();

  /* ---------- Sauts vers le formulaire d'achat ---------- */
  root.addEventListener('click',function(e){var a=e.target.closest('[data-pal-jump]');if(!a)return;var t=document.getElementById('pal-acheter');if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth'})}});
})();
